(function(Carousel) {
    'use strict';

    Carousel.carouselDefaultAutoplaySpeed = 4000;

    Carousel.init = function() {
        Carousel.header();
        Carousel.verticalBlocks();
        Carousel.results();
    };

    Carousel.header = function() {
        var timer = Carousel.carouselDefaultAutoplaySpeed;

        $('.js-carousel').slick({
            mobileFirst: true,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            responsive: [{
                breakpoint: 720,
                settings: {
                    autoplay: true,
                    autoplaySpeed: timer,
                    draggable: false,
                    pauseOnHover: false
                }
            }]
        });
    };

    Carousel.verticalBlocks = function() {
        $('.js-carousel-vertical-blocks').slick({
            mobileFirst: true,
            infinite: false,
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            responsive: [{
                breakpoint: 720,
                settings: {
                    slidesToShow: 4,
                    autoplay: true,
                    autoplaySpeed: Carousel.carouselDefaultAutoplaySpeed
                }
            }]
        });
    };

    Carousel.results = function() {
        $('.js-results').slick({
            mobileFirst: true,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            responsive: [{
                breakpoint: 720,
                settings: {
                    slidesToShow: 3
                }
            }]

        });

        $('.js-results-container').each(function() {
            var $controls = $(this).find('.js-results-controls');
            var $slider = $(this).find('.js-results');

            if (!$controls.length) {
                return;
            }

            var slidesToShow = $slider.slick('slickGetOption', 'slidesToShow');
            var slides = $slider.find('.slick-slide:not(.slick-cloned)').length;

            if (slides > slidesToShow) {
                $controls.attr('hidden', false).fadeIn();
            }
        });


        $('.js-results-slide').on('click', function(event) {
            event.preventDefault();

            $(this).parents('.js-results-container').find('.js-results').slick($(this).data('method'));
        });
    };

})(window.Way2web.Carousel = window.Way2web.Carousel || {});
